import React from "react";
import { Link } from "react-router-dom";
import styles from "../css/Introduce.css";
import 'html5-player/libs/assets/css/style.css';
import Html5Player from 'html5-player';
import {
  Loading,
} from "../tools/wechatBrower";
import {Slide} from "./App"

export const Header = ({ text }) => {
  return (
    <div
      style={{
        backgroundColor: "#AE5CC9",
        height: "2.133333rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 22px",
      }}
    >
      <span
        style={{
          color: "white",
          fontSize: "16px",
          fontFamily: "cursive",
          flex: 1,
        }}
      >
        {text}
      </span>
      <Link to="/">
        <div className={styles.right}>
          <img
            style={{ height: "30px" }}
            alt=""
            src={require("../static/logo.png")}
          ></img>
          <span className={styles.text}>
            返回
            <br />
            首页
          </span>
        </div>
      </Link>
    </div>
  );
};



export default class extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [
      ],
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false })
    }, 300);
  


  }

  render() {
    return (
      <div style={{ flex: 1 }}>
        <Header text="实验室介绍"></Header>
        <div className={styles.main}>

          {this.state.loading && (
            <Loading loading={this.state.loading}></Loading>
          )}
          {!this.state.loading && (
            <div >
              <Slide data={this.state.data}></Slide>

              <div className={styles.content}>
                <Link to="/IntroduceDetail" className={styles.item}>
                  <img
                    src={require("../static/实验室介绍.png")}
                    alt=""
                    style={{ width: "77px", display: "block", marginBottom: "0.5rem" }}
                  />
                  <span style={{ color: '#333333', fontSize: '16px' }}>
                    实验室介绍
                  </span>
                </Link>

                <Link to="/Culture" className={styles.item}>
                  <img
                    src={require("../static/实验室文化.png")}
                    alt=""
                    style={{ width: "77px", display: "block", marginBottom: "0.5rem" }}
                  />
                  <span style={{ color: '#333333', fontSize: '16px' }}>
                    实验室文化
                  </span>
                </Link>

                <Link to="/Artisan" className={styles.item}>
                  <img
                    src={require("../static/技术人员.png")}
                    alt=""
                    style={{ width: "77px", display: "block", marginBottom: "0.5rem" }}
                  />
                  <span style={{ color: '#333333', fontSize: '16px' }}>
                    技术团队
                  </span>
                </Link>

                {/* <Link to="/Expert" className={styles.item}>
                  <img
                    src={require("../static/专家介绍.png")}
                    alt=""
                    style={{ width: "77px", display: "block", marginBottom: "0.5rem" }}
                  />
                  <span style={{ color: '#333333', fontSize: '16px' }}>
                    专家介绍
                  </span>
                </Link> */}
              </div>

               <div style={{ width: "94.5%", marginLeft: "2.75%",marginTop:"31px" }}>
                <Html5Player
                  title="清华大学色谱与分离实验室"
                  file="https://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/%E8%A7%86%E9%A2%911.mp4"
                  poster="https://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/4461652364273_.pic.jpg"
                />
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Introduce.js